'use client'

import dynamic from 'next/dynamic'

import { RenderOnScroll } from '@/components/RenderOnScroll'

import type { TFaqSectionProps } from './FaQSection'

const DynamicFaqSection = dynamic(() =>
	import('./FaQSection').then((mod) => mod.FaQSection),
)

export const LazyFaqSection = (props: TFaqSectionProps) => (
	<RenderOnScroll element={<DynamicFaqSection {...props} />} />
)
